import { getReturnReasons } from "../lib/reasons.lib";
import type { ReturnReason } from "../types";
import { usePublicShop } from "../queries/use-public-shop";

export function useReturnReasons(shopId: string, lang?: string): ReturnReason[] {
  const { data: shop } = usePublicShop(shopId);
  return getReturnReasons(shop, lang);
}
